//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Instruction from './Instruction.vue'
export default {
  components: {
    Instruction,
  },
  props: {
    title: {
      type: String,
      default: 'Tu función en esta etapa:',
    },
  },
}
